import React, { Fragment, useContext, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Container, NavbarToggler, Collapse, Navbar } from 'reactstrap';
import styles from './NJRHeader.module.css';
import classnames from 'classnames';
import { ReactComponent as NJRLogo } from '../../../assets/images/Vendor/NJR/njr-retail-logo.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import { useMediaQuery } from 'react-responsive';
import getClientContent from '../../../components/_BrandingProvider/brandContent';
import { BrandingContext } from '../../../components/contexts/ContractContext';
import { useHistory } from 'react-router-dom';
import { stripPhoneNumber } from '../../shared/util';

const NJRHeader = () => {
    const history = useHistory();

    const [navOptions, setNavOptions] = useState(false);

    const { clientId } = useContext(BrandingContext);
    const { phone } = getClientContent(clientId).variableText.customerService;

    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

    const toggleNavbar = () => {
        setNavOptions(!navOptions);
    };

    return (
        <>
            <header>
                <div className={styles.callNum}>
                    <Container className='px-3'>
                        Call{' '}
                        <a
                            className='callLink'
                            aria-label='Customer Service Number'
                            href={`tel:${stripPhoneNumber(phone)}`}
                        >
                            {phone}
                        </a>
                    </Container>
                </div>
                <div className={styles.njrHeader}>
                    <Container className={styles.headerContainer}>
                        <div className={styles.njrLogoSec}>
                            <a
                                aria-label='click to go back to home screen'
                                href='#'
                                onClick={() => history.push('/')}
                                className={styles.njrLogo}
                            >
                                <NJRLogo />
                            </a>
                            <p className='mb-0'>Provided by AIG</p>
                        </div>
                        <Navbar
                            color='faded'
                            light
                            expand='md'
                            className={styles.mobileNav}
                        >
                            <NavbarToggler onClick={toggleNavbar} />
                            {!isMobile && (
                                <Collapse
                                    isOpen={navOptions}
                                    navbar
                                >
                                    <Nav
                                        navbar
                                        className={styles.navTabsNJR}
                                    >
                                        {clientId !== 'NJR' && (
                                            <NavItem>
                                                <NavLink
                                                    tabIndex={0}
                                                    className={classnames(styles.navLinkNJR, 'mr-5')}
                                                    onClick={() => history.push('/faq')}
                                                >
                                                    FAQs
                                                </NavLink>
                                            </NavItem>
                                        )}
                                        <NavItem>
                                            <NavLink
                                                tabIndex={0}
                                                className={styles.navLinkNJR}
                                                onClick={() => history.push('/contactus')}
                                            >
                                                Contact Us
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </Collapse>
                            )}
                        </Navbar>
                    </Container>
                </div>
            </header>

            {isMobile && (
                <>
                    <Collapse
                        isOpen={navOptions}
                        navbar
                        className={styles.mobileMenu}
                    >
                        <span
                            onClick={toggleNavbar}
                            className={styles.closeMenu}
                        >
                            <CloseIcon />
                        </span>
                        <Nav
                            navbar
                            className={styles.navTabsNJR}
                            onClick={toggleNavbar}
                        >
                            {clientId !== 'NJR' && (
                                <NavItem>
                                    <NavLink
                                        tabIndex={0}
                                        className={styles.navLinkNJR}
                                        onClick={() => history.push('/faq')}
                                    >
                                        FAQs
                                    </NavLink>
                                </NavItem>
                            )}
                            <NavItem>
                                <NavLink
                                    tabIndex={0}
                                    className={styles.navLinkNJR}
                                    onClick={() => history.push('/contactus')}
                                >
                                    Contact Us
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={styles.navLinkNJR}
                                    href={`tel:${stripPhoneNumber(phone)}`}
                                >
                                    Call{' '}
                                    <a
                                        className={`callLink ${styles.white}`}
                                        href={`tel:${stripPhoneNumber(phone)}`}
                                    >
                                        {phone}
                                    </a>
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </>
            )}
        </>
    );
};

export default NJRHeader;
